import React, { Component } from "react";

export default class TreatmentDesc extends Component {
  render() {
    let {     
      treatment = [],
      treatmentbal = false,
    } = this.props.footer;
    return (
      <div className="row pt-3">
        {treatmentbal && treatment && treatment.length > 0 && (
          <div className="col-md-7">
            <div className="d-flex prepaidDesContainer border1px">
              <div className="width80 ">
                <p className="text-center text-dark fw-600 ">Course </p>
              </div>
              <div className="width20 borderLeft1px">
                <p className="text-center  text-dark fw-600"> Total</p>
              </div>
            </div>
            <div className="borderTopHide">
              {treatment.map((list, id) => {
                return (
                  <div key={id} className="d-flex prepaidDesContainer ">
                    <div className="width80 ">
                      <p className="text-center text-dark fs-12 ">
                        {list?.course}
                      </p>
                    </div>
                    <div className="width20 ">
                      <p className="text-center text-dark fs-12">
                        {" "}
                        {list?.total}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}
